export default __webpack_public_path__ + "443ed6a7f66f27b282f3f166a5e3c8ed.ttf";